import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    text: 'Das OOPBUY Spreadsheet hat meine Suche nach günstigen Sneakern komplett verändert. Die Übersicht ist unglaublich hilfreich und ich spare jede Woche Stunden an Recherchezeit.',
    name: 'Lukas M.',
    info: 'aus Berlin',
    rating: 4.9,
  },
  {
    id: 2,
    text: 'Ich war anfangs skeptisch, aber die detaillierten QC Informationen im Spreadsheet haben mich überzeugt. Perfekt für Einsteiger und erfahrene Käufer gleichermaßen.',
    name: 'Sophie K.',
    info: 'aus München',
    rating: 4.8,
  },
  {
    id: 3,
    text: 'Endlich eine deutschsprachige Ressource, die alle wichtigen Informationen zu OOPBUY an einem Ort bündelt. Das Spreadsheet ist Gold wert für den Preisvergleich.',
    name: 'Maximilian R.',
    info: 'aus Hamburg',
    rating: 4.9,
  },
];

export default function Testimonial() {
  const [current, setCurrent] = useState(0);

  const prev = () => {
    setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  };

  const next = () => {
    setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));
  };

  const t = testimonials[current];

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs tracking-widest uppercase text-accent-500 font-medium mb-2">
            Erfahrungen
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-12">
            Was Nutzer über das OOPBUY Spreadsheet sagen
          </h2>
        </div>

        <div className="max-w-2xl mx-auto relative">
          <div className="bg-background-100 rounded-2xl p-8 md:p-12">
            <div className="flex items-center gap-1.5 mb-6">
              {[1, 2, 3, 4, 5].map((star) => (
                <span key={star} className="text-amber-400 text-sm">
                  ★
                </span>
              ))}
              <span className="text-sm font-medium text-foreground-700 ml-2">{t.rating}</span>
            </div>

            <blockquote className="text-lg md:text-xl font-heading italic text-foreground-800 leading-relaxed mb-8">
              &ldquo;{t.text}&rdquo;
            </blockquote>

            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center">
                <span className="text-accent-700 text-sm font-medium">
                  {t.name.charAt(0)}
                </span>
              </div>
              <div className="text-left">
                <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                <p className="text-xs text-foreground-500">{t.info}</p>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-3 mt-6">
            <button
              onClick={prev}
              className="w-10 h-10 rounded-full border border-secondary-300 hover:border-secondary-400 flex items-center justify-center transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-foreground-600" />
            </button>
            <button
              onClick={next}
              className="w-10 h-10 rounded-full bg-primary-500 hover:bg-primary-600 flex items-center justify-center transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line text-white" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}